import styles from './styles.module.scss';

import cn from 'classnames';

const TextGrey = ({ fontSize, fontWeight, right = false, className, ...props }) => (
  <div
    className={cn(styles.grey_text, right && styles.right, className, props.styles)}
    style={{ fontSize, fontWeight, ...props.style }}
    {...props}
  >
    {props.children}
  </div>
);

export default TextGrey;
